export default __webpack_public_path__ + "static/home-page-career-arts-13928a177235f245ffda6e2b6df35db1.png";